export const GUARANTEE_TYPE_NAMES = {
  participation: { full: "На участие в торгах", short: "На участие" },
  execution: { full: "На исполнение обязательств по контракту", short: "На исполнение" },
  returnAdvance: { full: "На возврат аванса", short: "На возврат аванса" },
  period: { full: "На обеспечение гарантийных обязательств", short: "На гарантийный период" },
};

export const GUARANTEE_OPTIONS_AGENT = [
  { key: "participation", value: GUARANTEE_TYPE_NAMES["participation"].full },
  {
    key: "execution",
    value: GUARANTEE_TYPE_NAMES["execution"].full,
  },
  { key: "returnAdvance", value: GUARANTEE_TYPE_NAMES["returnAdvance"].full },
  {
    key: "period",
    value: GUARANTEE_TYPE_NAMES["period"].full,
  },
];

export const GUARANTEE_OPTIONS = [
  { key: "На участие в торгах", value: "На участие в торгах" },
  {
    key: "На исполнение обязательств по контракту",
    value: "На исполнение обязательств по контракту",
  },
  { key: "На возврат аванса", value: "На возврат аванса" },
  {
    key: "На обеспечение гарантийных обязательств",
    value: "На обеспечение гарантийных обязательств",
  },
];
